import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Referee } from '../../../types/types';

interface Props {
  value: Referee | null;
  onChange?: (referee: Referee) => void;
  options: Referee[];
  onDelete?: (matchRefId: string) => void;
  disable: boolean;
}

export default function RefereesSelector({ value, onChange, options, onDelete, disable }: Props) {

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (referee: Referee) => {
    if (onChange) onChange(referee);
    handleClose();
  };

  const handleDeleteReferee = () => {
    value?.matchRefId && onDelete && onDelete(value.matchRefId);
    handleClose();
  }

  return (
    <>
      <Button
        id="basic-button"
        disabled={disable}
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleButtonClick}
        sx={{ color: value ? 'grey' : 'orange', fontStyle: value ? 'italic' : 'normal', fontSize: 10, margin: 0, padding: 0 }}
      >
        {value ? value.name : 'Add Referee'}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {options.map((referee) => (
          <MenuItem
            key={referee?.id}
            selected={value?.id === referee?.id}
            onClick={() => handleMenuItemClick(referee)}
          >
            {referee?.name}
          </MenuItem>
        ))}
        {value && (
          <MenuItem
            key="delete"
            onClick={handleDeleteReferee}
            sx={{ color: 'red' }}
          >
            Slet dommer
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
